export const SURVEY_TEXT = 'Provide feedback about this Learning Experience.'
export const LAUNCH_ACTIVITY_BUTTON_TEXT = 'Launch Activity'
export const LAUNCH_LESSON_BUTTON_TEXT = 'Launch Lesson'
export const PREVIEW_BUTTON_TEXT = 'Preview'
